<res-base-modal [modalTitle]="'Update Export Volume'" [modalClass]="modalClass" [modalAutomationId]="automationId"
    [primaryButtonLabel]="'Update'" (primaryButtonActionEmt)="ok()" (closeButtonActionEmt)="closeModal()"
    [isPrimaryBtnEnabled]="!isBusy && okEnabled()" [secondaryButtonLabel]="'Cancel'" [(isBusy)]="isBusy"
    [(isBusyMessage)]="isBusyMessage" [modalHelpIndex]="modalHelpIndex" [modalHasVariableHeight]="true"
    [modalHasVariablePosition]="true">

    <div>
        <div class="export-row export-row-padded-left-right export-row-padded-top">
            <div class="export-row-column-first">
                <label requiredAsterisk>Export Data Area:</label>
            </div>
            <div class="export-row-column-second">
                <select [attr.data-automation-id]="'export-modal-export-data-area'"
                    [(ngModel)]="exportOptions.dataAreaHandle" (blur)="validation.dataAreaHandle.check()"
                    [(resScrollablePopover)]="validation.dataAreaHandle.invalid"
                    [popoverErrorMessage]="validation.dataAreaHandle.errorMessage" popoverType="error"
                    popoverPlacement="bottom" [popoverAutomationId]="'export-modal-export-data-area-error-message'">
                    <option *ngFor="let dataArea of extraOptions.exportDataAreas" [ngValue]="dataArea.handle">
                        {{dataArea.name}}</option>
                </select>
            </div>
        </div>
        <div class="export-row export-row-padded">
            <div class="export-row-column-first">
                <label>Update Option:</label>
            </div>
            <div class="export-row-column-second">
                <button [attr.data-automation-id]="automationId + '-retry-production-errors-only-toggle-button'"
                    type="button"
                    [ngClass]="updateOption == 'retryProductionErrorsOnly' ? 'btn-group-active' : 'btn-group-default'"
                    (click)="onChange.updateOption('retryProductionErrorsOnly')">
                    <div>Retry Production Errors Only</div>
                    <i class="fa fa-caret-up up-caret-active"></i>
                </button>
                <button [attr.data-automation-id]="automationId + '-add-output-formats-toggle-button'" type="button"
                    [ngClass]="updateOption == 'addOutputFormats' ? 'btn-group-active' : 'btn-group-default'"
                    (click)="onChange.updateOption('addOutputFormats')">
                    <div>Add Output Formats</div>
                    <i class="fa fa-caret-up up-caret-active"></i>
                </button>
                <button [attr.data-automation-id]="automationId + '-redo-entire-production-toggle-button'" type="button"
                    [ngClass]="updateOption == 'redoEntireProduction' ? 'btn-group-active' : 'btn-group-default'"
                    (click)="onChange.updateOption('redoEntireProduction')">
                    <div>Redo Entire Production</div>
                    <i class="fa fa-caret-up up-caret-active"></i>
                </button>
            </div>
        </div>
        <div class="export-row export-row-padded-bottom update-settings"
            *ngIf="updateOption == 'addOutputFormats' || updateOption == 'redoEntireProduction'">
            <div class="export-header">Formatting Settings</div>
            <div class="export-row export-row-padded-left-right export-row-padded-top">
                <label [ngClass]="[updateOption == 'addOutputFormats' ? 'disabled' : '']">Time
                    Zone:</label>
            </div>
            <div class="export-row export-row-padded-left-right export-row-padded-bottom format-settings">
                <select [disabled]="updateOption == 'addOutputFormats'"
                    [attr.data-automation-id]="'export-modal-timezone-select'" [(ngModel)]="exportOptions.timezone"
                    (change)="onChange.selectedTimezone()">
                    <option *ngFor="let timezone of extraOptions.timezones" [ngValue]="timezone.id"
                        [disabled]="timezone.id == ''">{{timezone.description}}</option>
                </select>
            </div>
            <div class="export-header">Production Settings</div>
            <res-export [selectedExportStream]="selectedExportStream" [selectedExportVolume]="selectedExportVolume"
                [optionsDisabled]="optionsDisabled" [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage"
                [exportOptionsFromUpdateExportVolume]="exportOptions" [automationId]="'export-modal'"
                [disabledFields]="disabled" [isupdateExportVolume]="true"
                [enableSearchTermQueries]="enableSearchTermQueries"></res-export>
        </div>
    </div>
</res-base-modal>